import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';
import SlideGroupRowActions from './SlideGroupRowActions';
import { SlideGroup } from './utils';

interface ColumnOptions {
  onDelete: (group: SlideGroup) => void;
  onEdit: (group: SlideGroup) => void;
}

const columnHelper = createColumnHelper<SlideGroup>();

// Every column is unsortable: the rows are drag-reorderable, and the table asks for the data order
// to be the display order when reorder is on.
const slideGroupColumns = ({ onDelete, onEdit }: ColumnOptions): ColumnDef<SlideGroup, unknown>[] => [
  columnHelper.display({
    cell: info => <span className="tw-tabular-nums tw-text-spa-tertiary">{info.row.index + 1}</span>,
    enableSorting: false,
    header: '#',
    id: 'position',
    size: 40,
  }),
  columnHelper.accessor('titleEn', {
    enableSorting: false,
    header: 'Title',
    meta: { width: 'auto' },
  }),
  columnHelper.accessor(group => group.slides.length, {
    enableSorting: false,
    header: '# of Slides',
    id: 'slidesLength',
    meta: { align: 'right' },
    size: 120,
  }),
  columnHelper.display({
    cell: info => <SlideGroupRowActions group={info.row.original} onDelete={onDelete} onEdit={onEdit} />,
    enableSorting: false,
    header: 'Actions',
    id: 'actions',
    size: 100,
  }),
];

export default slideGroupColumns;
